import { Subject, Observable } from 'rxjs';
import { share, publishReplay, publish } from 'rxjs/operators';
import { Project, ProjectEvent } from '../../model/project';
import { translate } from '../translation/translation'
//import {getCategoryData} from "@/services/getCategoryData/getCategoryData";
import { getProjects, vote } from '../webclient/webclient';
import {
    getCountryTranslations,
    getLifechallengeCategoryUrl1,
    getLifechallengeCategoryUrl2, getLifechallengeCategoryUrl3,
    getLifechallengeCategoryUrl4,
    getLifechallengeCategoryUrl5, getLifechallengeCategoryUrl6
} from "@/services/getCategoryData/getCategoryData";
import set = Reflect.set;
import Vue from 'vue';
import { getCookie, setCookie } from "@/services/cookieClient/cookieClient";
import { getVotingEnabledData } from "@/services/getProjectData/getProjectData";

declare let category: number;
declare let year: string;

export class CategoryData {

    private year;
    private _data: Observable<ProjectEvent>;
    public get data(): Observable<ProjectEvent> {
        return this._data;
    }

    private _projects: Project[] = [];
    public get projects(): Project[] {
        return this._projects;
    }
    public set projects(v: Project[]) {
        this._projects = v;
        (this.data as Subject<ProjectEvent>).next({ event: 'fetch', data: v });
    }

    private _votes: { id: string, vote: string, currentPosition: string}[] = [];
    public get votes(): { id: string, vote: string, currentPosition: string }[] {
        return this._votes;
    }
    public set votes(v: { id: string, vote: string, currentPosition: string }[]) {
        this._votes = v;
    }


    private _countries: { id: string, value: string }[] = [];
    public get countries(): { id: string, value: string }[] {
        return this._countries;
    }
    public set countries(v: { id: string, value: string }[]) {
        this._countries = v;
    }

    private _country: { id: string, value: string } | null = null;
    public get country(): { id: string, value: string } | null {
        return this._country;
    }

    public set country(v: { id: string, value: string } | null) {
        this._country = v;
    }

    private _category: { id: number, name: string } | null = null;
    public get category(): { id: number, name: string } | null {
        return this._category;
    }

    public set category(v: { id: number, name: string } | null) {
        this._category = v;
        if (v != null) {
            this.updateCountry(v.id);
        }

    }

    private _best10: number[] = [];
    public get best10(): number[] {
        // return [2221, 2222, 2217]; //this._best10;
        return this._best10;
    }
    public set best10(v: number[]) {
        this._best10 = v;
    }

    getYear() {
        if ( year ) {
            return year;
        }
        return '';
    }


    updateProjects() {
        if (this.category && this._category!.id > 0) {
            getProjects(this.getYear(), this._category!.id, this._country != null ? this._country!.id : "")
                .then(data => {
                    this.projects = data.projects;
                    this.votes = data.voted;
                    this.best10 = data.best10;
                })
                .catch(err => console.log(err));
        }
    }

    getVote(id) {
        let vote = this.getVoteData(id)
        if (vote) {
            return vote.vote;
        }
        return null;
    }

    getVoteData(id) {
        let vote = this.votes.filter(vote => vote.id == id);
        if (vote.length) {
            return vote[0];
        }
        return null;
    }

    updateVote(year, projId, points) {
        vote(year, projId, points).then(result => {
            if (result.status > 0) {
                let vote = this.getVoteData(projId);
                if (vote){

                    vote.vote = points;
                    vote.currentPosition = result.current_position;
                } else{
                    this.votes.push({ id: projId, vote: points , currentPosition: "-1" });
                }
                (this.data as Subject<ProjectEvent>).next({
                    event: 'voteSuccess',
                    data: { vote: points, id: projId , currentPosition: result.current_position }
                });
            }
        })
    }

    updateCountry(categoryId) {
        let allCountries = getCountryTranslations();
        let selectedCountry: any = this.country;
        this.countries = allCountries[categoryId - 1];

        if (selectedCountry != null) {
            //country update
            let availebleCountry = false;
            $.each(this.countries, (index, countr) => {
                if (countr.id == selectedCountry.id) {
                    availebleCountry = true;
                }
            });
            if (!availebleCountry) {
                this.country = allCountries[categoryId - 1][0];
                setCookie('country', JSON.stringify(this.country), 1);
            }
        }
    }


    constructor() {
        this._data = new Subject<ProjectEvent>();

        //data from blade
        //category page
        if ((self as any).category) {
            const cat = this.categories.filter(cat => cat.id == category);
            if (cat.length > 0)
                this.category = cat[0];
        }

        //data from blade
        //year
        if ((self as any).year) {
            this.year = year;
        }


        if (typeof category != "undefined") {
            let allCountries = getCountryTranslations();
            let categoryId: any = category;
            let storedSelectedCountry: any = getCookie('country');
            this.countries = allCountries[categoryId - 1];

            if (getVotingEnabledData()) {
                this.country = allCountries[categoryId - 1][0];
                setCookie('country', JSON.stringify(this.country), 1);
            } else if (!getVotingEnabledData() && storedSelectedCountry != "") {
                let avaible = false;
                $.each(this.countries, (index, county) => {
                    if (county.id == JSON.parse(storedSelectedCountry).id) {
                        avaible = true;
                    }
                });
                if (avaible) {
                    this.country = JSON.parse(storedSelectedCountry);
                } else {
                    this.country = allCountries[categoryId - 1][0];
                }
            } else {
                this.country = allCountries[categoryId - 1][0];
            }
        }



        //project page
        if ((self as any).projectData) {
            this.projects = [(self as any).projectData];
        }
        if ((self as any).vote) {
            this.votes = [(self as any).vote];
        }

        this.updateProjects();



    }


    private _categories: { id: number, name: string, url: string }[] = [
        { id: 1, name: 'lifechallenge_category_single', url: getLifechallengeCategoryUrl1() },
        { id: 2, name: 'lifechallenge_category_multi', url: getLifechallengeCategoryUrl2() },
        { id: 3, name: 'lifechallenge_category_non_residental', url: getLifechallengeCategoryUrl3() },
        { id: 4, name: 'lifechallenge_category_thermal', url: getLifechallengeCategoryUrl4() },
        { id: 5, name: 'lifechallenge_category_historical', url: getLifechallengeCategoryUrl5() },
        { id: 6, name: 'lifechallenge_category_sbtexture', url: getLifechallengeCategoryUrl6() }
    ];
    public get categories(): { id: number, name: string }[] {
        return this._categories.map(cat => {
            cat.name = translate(cat.name);
            return cat;
        });
    }
}